import { baseTypography } from './baseTypography';
const headline = {
    extraLarge: {
        untilMd: {
            fontSize: baseTypography.font.size['25'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.tight,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['56'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.tight,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    large: {
        untilMd: {
            fontSize: baseTypography.font.size['22'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.tight,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['44'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.tight,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    medium: {
        untilMd: {
            fontSize: baseTypography.font.size['20'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.medium,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['36'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.tight,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    small: {
        untilMd: {
            fontSize: baseTypography.font.size['17'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['28'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    extraSmall: {
        untilMd: {
            fontSize: baseTypography.font.size['16'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['18'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    extraExtraSmall: {
        untilMd: {
            fontSize: baseTypography.font.size['13'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['14'],
            fontWeight: baseTypography.font.weight['700'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    micro: {
        untilMd: {
            fontSize: baseTypography.font.size['12'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['12'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
};
const body = {
    default: {
        untilMd: {
            fontSize: baseTypography.font.size['14'],
            fontWeight: baseTypography.font.weight['400'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['14'],
            fontWeight: baseTypography.font.weight['400'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    large: {
        untilMd: {
            fontSize: baseTypography.font.size['16'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['16'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    medium: {
        untilMd: {
            fontSize: baseTypography.font.size['14'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['14'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    small: {
        untilMd: {
            fontSize: baseTypography.font.size['13'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['13'],
            fontWeight: baseTypography.font.weight['600'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    micro: {
        untilMd: {
            fontSize: baseTypography.font.size['12'],
            fontWeight: baseTypography.font.weight['400'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['12'],
            fontWeight: baseTypography.font.weight['400'],
            lineHeight: baseTypography.font.lineHeight.looser,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    nano: {
        untilMd: {
            fontSize: baseTypography.font.size['11'],
            fontWeight: baseTypography.font.weight['400'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['11'],
            fontWeight: baseTypography.font.weight['400'],
            lineHeight: baseTypography.font.lineHeight.loose,
            letterSpacing: baseTypography.font.letterSpacing.medium,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
    tiny: {
        untilMd: {
            fontSize: baseTypography.font.size['9'],
            fontWeight: baseTypography.font.weight['500'],
            lineHeight: baseTypography.font.lineHeight.medium,
            letterSpacing: baseTypography.font.letterSpacing.wide,
            fontFamily: baseTypography.font.family.sanSerif,
        },
        fromMd: {
            fontSize: baseTypography.font.size['9'],
            fontWeight: baseTypography.font.weight['500'],
            lineHeight: baseTypography.font.lineHeight.medium,
            letterSpacing: baseTypography.font.letterSpacing.wide,
            fontFamily: baseTypography.font.family.sanSerif,
        },
    },
};
const effect = {
    uppercase: {
        letterSpacing: baseTypography.font.letterSpacing.wide,
    },
};
export const themeTypography = {
    ...baseTypography,
    headline,
    body,
    effect,
};
//# sourceMappingURL=themeTypography.js.map